export const Errors = {
  genericLine1Error: "We cannot process your order at this time.",
  genericLine2Error: "Please try again later.",
  shipmentsNotValidLine1: "Some of your selections are no longer valid",
  shipmentsNotValidLine2: "Please review your cart.",
  inventoryError: "Error submitting order. Item(s) on order are out of stock",
  passwordNotMeetSecurity: "Password does not meet security requirements.",
  giftCardInventoryExceeded:
    "Your order exceeds the number of Gift Cards we have available. <br> Please update your cart or contact (612) 861-7311 for assistance.",
  giftCardProcessingError:
    "We cannot process your Gift Card order at this time. <br> Please contact (612) 861-7311 for assistance.",
  giftCardNotAvailable: "cardNumber not available",
  avsResponseCodeMessageForBENLine1:
    "The billing address provided does not match the one on file with your bank. Please check your street address and ZIP code and try again.",
  avsResponseCodeMessageForBENLine2:
    "Note: If you see a “pending” charge on your bank statement, it is a temporary hold that will automatically drop off within 3–5 business days. You have not been charged.",
  avsRResponseCodeMessageLine1:
    "We’re having trouble connecting to your bank to verify your billing information. Please try submitting your order again in a few minutes, or use a different payment method.",
  avsRResponseCodeMessageLine2:
    "Note: If you see a “pending” charge on your bank statement, it is a temporary hold that will automatically drop off within 3–5 business days. You have not been charged.",
  avsGResponseCodeMessageLine1:
    "Your bank does not currently support our automated address verification security check. Please try an alternative payment method or a different card.",
  avsGResponseCodeMessageLine2:
    "Note: If you see a “pending” charge on your bank statement, it is a temporary hold that will automatically drop off within 3–5 business days. You have not been charged.",
};
